<div [caLocalizationScope]="localizationScope">
  <p class="mb-7">{{ reportDescriptionTitle | caLocalize }}</p>
  <div class="heading-20 mb-2">{{ sectionsTitle | caLocalize }}</div>
  <ng-content></ng-content>
</div>
